import { useEffect, useRef, useState } from 'react';
import { useIsWideDesktop } from '@ui/utils/useDeviceType';
import { useLocation } from 'react-router';
import { usePrimisVideoSpace } from './usePrimisVideoSpace';

// TODO: extracto a client-specific constant
const stickyHeaderHeight = 140;

const SIDEBAR_ADS = [
  <div className="sticky-sidebar-ad" id="snack-sidebar-outer">
    <div id="snack-sidebar-3" />
  </div>,
  <div className="sticky-sidebar-ad" id="snack-sidebar-outer">
    <div id="snack-sidebar-2" />
  </div>,
  <div className="sticky-sidebar-ad" id="snack-incontent-1" />,
  <div className="sticky-sidebar-ad" id="snack-incontent-2" />,
  <div className="sticky-sidebar-ad" id="snack-incontent-3" />,
  <div className="sticky-sidebar-ad" id="snack-incontent-repeater" />,
];

export function SidebarAds() {
  const isWideDesktop = useIsWideDesktop();
  const [numberOfAds, setNumberOfAds] = useState<number | null>(1);
  const location = useLocation();
  const [url, setUrl] = useState(`${location.pathname}${location.search}`);
  const videoSlotRef = useRef<HTMLDivElement>(null);

  usePrimisVideoSpace(videoSlotRef);

  useEffect(() => {
    const newUrl = `${location.pathname}${location.search}`;

    if (newUrl !== url) {
      setNumberOfAds(1);
      setUrl(newUrl);

      // @ts-expect-error FWP function
      if (typeof initEmbeds === 'function') {
        // @ts-expect-error FWP function
        initEmbeds();
      }
    }
  }, [location, url]);

  useEffect(() => {
    /**
     * timeout is needed as we want to do the calculations only when all the component requests
     * have finished loading the data
     */
    setTimeout(() => {
      // Calculate how many pairs of divs we need based on the initial viewport height
      const height = document.documentElement.scrollHeight - stickyHeaderHeight;
      const calculatedNumberOfAds = Math.floor(height / 1000);

      setNumberOfAds(Math.min(calculatedNumberOfAds, SIDEBAR_ADS.length));
    }, 1000);
  }, [location.pathname]);

  return (
    <aside className="sidebar-ads-container">
      <div className="matches-list__video-ad" id="snack-vod" ref={videoSlotRef} />
      {typeof numberOfAds === 'number' &&
        numberOfAds > 0 &&
        isWideDesktop &&
        Array.from({ length: numberOfAds }).map((_, index) => (
          <div className={'sidebar-ad'} key={`sidebar-ads-${index}`}>
            {SIDEBAR_ADS[index]}
          </div>
        ))}
    </aside>
  );
}
